var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h5 c-gray70 m-b-3",attrs:{"selenium":"job-request-section-heading"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }